import { tutorChatTypes } from './Constants';

const initialState = {
	chosenDepartment: null,
	chosenDepartmentTutorAvailable: false,
	tutorChatSubscription: false,
	tutorDepartments: [],
	isPublic: false,
	open: false,
	visible: false,
	blocked: false,
	noMenu: false,
	source: null,
	loadingAiChat: false,
	loadingChatHistory: false,
	loadingPrevHistory: false,
	loadingAiMessage: false,
	conversation: null,
	conversationHistory: null,
	message: null,
	authCall: null,
	internalAPI: false,
};

export default function aiChatReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};
	const { result, isHistory, prevHistory } = data || {};

	switch (type) {
		case tutorChatTypes.SET_AI_CHAT_DATA:
			return {
				...state,
				...data,
			};

		case tutorChatTypes.AI_CHAT_INIT:
			return {
				...state,
				loadingAiChat: !data.preventLoading,
			};
		case tutorChatTypes.AI_CHAT_INIT_SUCCESS:
		case tutorChatTypes.AI_CHAT_INIT_ERROR:
			return {
				...state,
				loadingAiChat: false,
			};

		case tutorChatTypes.GET_AI_CHAT_HISTORY:
			return {
				...state,
				loadingChatHistory: true,
				loadingPrevHistory: !!prevHistory,
			};
		case tutorChatTypes.GET_AI_CHAT_HISTORY_SUCCESS:
			return {
				...state,
				loadingChatHistory: false,
				loadingAiChat: false,
				loadingPrevHistory: false,
				conversation: isHistory ? state.conversation : result,
				conversationHistory: isHistory ? result : state.conversationHistory,
			};
		case tutorChatTypes.GET_AI_CHAT_HISTORY_ERROR:
			return {
				...state,
				loadingChatHistory: false,
				loadingPrevHistory: false,
				loadingAiChat: false,
			};

		case tutorChatTypes.AI_CONVERSATION:
			return {
				...state,
				authCall: null,
				loadingAiChat: false,
				loadingAiMessage: true,
				loadingAiMessageCombined: true,
			};
		case tutorChatTypes.AI_EVENT_STREAM_MESSAGE:
			return {
				...state,
				loadingAiMessage: false,
				message: state.message
					? { ...state.message, text: `${state.message.text}${data.text}` }
					: data,
			};
		case tutorChatTypes.STOP_AI_EVENT_STREAM:
			return {
				...state,
				message: null,
				loadingAiChat: false,
				loadingAiMessage: false,
				loadingAiMessageCombined: false,
				...data,
			};
		case tutorChatTypes.CLEAR_AI_CHAT_STATE:
			return initialState;
		default:
			return state;
	}
}
